import React from "react";
// mui
import { MenuItem, ListItemIcon } from "@mui/material";
// icons
import { IoIosLogOut } from "react-icons/io";

type Props = {
  onClick: () => void;
};

const LogoutButton = ({ onClick }: Props) => {
  return (
    <MenuItem onClick={onClick} sx={{ color: "error.main" }}>
      <ListItemIcon sx={{ color: "inherit", minWidth: "32px" }}>
        <IoIosLogOut />
      </ListItemIcon>
      تسجيل الخروج
    </MenuItem>
  );
};

export default LogoutButton;
